import Bold from './bold';

class Italic extends Bold { }
Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];

export default Italic;



// WEBPACK FOOTER //
// ./formats/italic.js